import { Route } from 'react-router-dom';

import { JabraView } from './jabra.view';

export const settingsIntegrationsJabraRoutes = (
  <Route path="jabra">
    <Route path="" element={<JabraView />} />
  </Route>
);
